/** Must match inline script in `index.html` (avoid FOUC). */
export const COLOR_SCHEME_PREFERENCE_STORAGE_KEY = 'ies-color-scheme-preference';

export type ResolvedColorScheme = 'light' | 'dark';

export type ColorSchemePreference = 'system' | 'light' | 'dark';

/** Read stored preference; defaults to `system`. */
export function readStoredColorSchemePreference(): ColorSchemePreference {
  if (typeof window === 'undefined') return 'system';
  try {
    const raw = localStorage.getItem(COLOR_SCHEME_PREFERENCE_STORAGE_KEY);
    if (raw === 'light' || raw === 'dark' || raw === 'system') return raw;
  } catch {
    /* ignore */
  }
  return 'system';
}

/** Effective light/dark from preference + `prefers-color-scheme` when `system`. */
export function resolveColorScheme(
  preference: ColorSchemePreference,
  systemIsDark: boolean,
): ResolvedColorScheme {
  if (preference === 'light') return 'light';
  if (preference === 'dark') return 'dark';
  return systemIsDark ? 'dark' : 'light';
}
